// Split markdown string into an array of strings
// Remove leading dashes from each line
export const convertMarkdownInclusionsToArray = (markdown: string): string[] => {
  return markdown?.split('\n').map(line => line.trim()
    .replace(/^[-]/, ''))
    .filter(line => line !== '')
}
